import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function company(state = initialState.company, action) {
    switch (action.type) {
        case types.LOAD_COMPANIES_REQUEST:
            return Object.assign({}, state, {
                companies: {
                    ...state.companies,
                    isFetching: true,
                }
            })
        case types.LOAD_COMPANIES_SUCCESS:
            return Object.assign({}, state, {
                companies: {
                    ...state.companies,
                    isFetching: false,
                    errorMessage: '',
                    data: action.payload
                }
            })
        case types.LOAD_COMPANIES_FAILURE:
            return Object.assign({}, state, {
                companies: {
                    ...state.companies,
                    isFetching: false,
                    errorMessage: {
                        ...action.payload
                    }
                }
            })

        case types.CREATE_COMPANY_REQUEST:
            return Object.assign({}, state, {
                companies: {
                    ...state.companies,
                    creating: true,
                }
            })
        case types.CREATE_COMPANY_SUCCESS:
            return Object.assign({}, state, {
                companies: {
                    ...state.companies,
                    creating: false,
                    errorMessage: '',
                    data: {
                        ...state.companies.data,
                        results: [
                            action.payload,
                            ...state.companies.data.results,
                        ]
                    }
                }
            })
        case types.CREATE_COMPANY_FAILED:
            return Object.assign({}, state, {
                companies: {
                    ...state.companies,
                    creating: false,
                    errorMessage: {
                        ...action.payload
                    }
                }
            })

        case types.UPDATE_COMPANY_DATA_REQUEST:
            return Object.assign({}, state, {
                companies: {
                    ...state.companies,
                    //isFetching: true,
                }
            })
        case types.UPDATE_COMPANY_DATA_SUCCESS:
            const updateData = Object.assign({}, state);

            let indexUpdate = state.companies.data.results.findIndex(company =>
                company.id === action.payload.id
            );

            updateData.companies.data.results.splice(indexUpdate, 1, action.payload);

            return updateData;
        case types.UPDATE_COMPANY_DATA_FAILURE:
            return Object.assign({}, state, {
                companies: {
                    ...state.companies,
                    // isFetching: false,
                    errorMessage: {
                        ...action.payload
                    }
                }
            })

        case types.PUT_COMPANY_BALANCE_REQUEST:
            return Object.assign({}, state, {
                //isFetching: true,
                //updateBalance
            })
        case types.PUT_COMPANY_BALANCE_SUCCESS:
            const newState = Object.assign({}, state);

            let indexToUpdate = state.companies.data.results.findIndex(company =>
                company.id === action.payload.id
            );
            
            newState.companies.data.results.splice(indexToUpdate, 1, action.payload);
            
            return newState;
        case types.PUT_COMPANY_BALANCE_FAILURE:
            return Object.assign({}, state, {
                companies: {
                    ...state.companies,
                    // isFetching: false,
                    errorMessage: {
                        ...action.payload
                    }
                }
            })
        
        case types.WRITE_OFF_MONEY_COMPANY:
            const newCompanyState = Object.assign({}, state);

            let newcompany = state.companies.data.results.filter(company =>
                company.id == action.data.company_id
            );

            let indexCompany = state.companies.data.results.findIndex(company =>
                company.id == action.data.company_id
            );
            
            if(newcompany.length){
                let newBalance = (parseFloat(newcompany[0].balance) - parseFloat(action.data.price));
                newCompanyState.companies.data.results.splice(indexCompany, 1, {
                    ...newcompany[0],
                    balance: newBalance
                });
            }

            return newCompanyState;

        case types.LOAD_COMPANY_TRANSACTIONS_REQUEST:
            return Object.assign({}, state, {
                transactions: {
                    ...state.transactions,
                    isFetching: true,
                }
            })
        case types.LOAD_COMPANY_TRANSACTIONS_SUCCESS:
            return Object.assign({}, state, {
                transactions: {
                    ...state.transactions,
                    isFetching: false,
                    errorMessage: '',
                    data: action.payload
                }
            })
        case types.LOAD_COMPANY_TRANSACTIONS_FAILURE:
            return Object.assign({}, state, {
                transactions: {
                    ...state.transactions,
                    isFetching: false,
                    errorMessage: {
                        ...action.payload
                    }
                }
            })

        case types.LOAD_COMPANY_INVOICES_SUCCESS:
            return Object.assign({}, state, {
                invoices: {
                    ...state.invoices,
                    data: action.payload
                }
            })
        case types.ADD_COMPANIES_INVOICE:
            return Object.assign({}, state, {
                invoices: {
                    ...state.invoices,
                    data: {
                        ...state.invoices.data,
                        results: [
                            action.payload,
                            ...state.invoices.data.results,
                        ]
                    }
                }
            })

        case types.RESET_ALL_INFO:
            return initialState.company

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/companyReducer.js